import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20romantic%20lace%20texture%20background%20in%20cream%20and%20ivory%20tones%2C%20delicate%20floral%20patterns%2C%20dreamy%20atmospheric%20textile%20art%2C%20elegant%20luxury%20aesthetic%2C%20warm%20neutral%20color%20palette%2C%20soft%20defocused%20background%20with%20subtle%20lace%20details&width=1920&height=600&seq=newsletter-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-background-950/70"></div>
      <div className="relative z-10 mx-auto text-center" style={{ maxWidth: '600px' }}>
        <p className="text-accent-300 text-sm tracking-[0.2em] uppercase mb-3 font-label">Newsletter</p>
        <h2 className="font-heading text-2xl md:text-4xl font-semibold text-background-50 mb-4">
          订阅蕾丝雅集资讯
        </h2>
        <p className="text-background-300 text-sm md:text-base mb-8 leading-relaxed">
          第一时间获取蕾丝新品发布、穿搭灵感和专属优惠信息。
        </p>
        {submitted ? (
          <p className="text-accent-300 text-base font-medium">
            <i className="ri-check-line mr-2"></i>订阅成功！感谢您的关注，我们会将最新资讯发送到您的邮箱。
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 px-5 py-3 text-sm bg-background-50/95 border border-background-300 text-foreground-900 placeholder:text-foreground-500 outline-none rounded-md focus:border-primary-500 transition-colors duration-200"
            />
            <button
              type="submit"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即订阅
            </button>
          </form>
        )}
      </div>
    </section>
  );
}